import * as Library from '../../../../lib/core/library/index';

export class Transmission {
  public transmissionType: string;

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    this.transmissionType = Library.init(options, 'transmissionType');
  }
}
